import { z } from 'zod'

/** Envelope canónico para cualquier listado cursor-paginado de API v2. */
export const V2CursorPaginationSchema = z.object({
  nextCursor: z.string().nullable(),
  previousCursor: z.string().nullable(),
  pageSize: z.number().int().min(1).max(500),
  hasMore: z.boolean()
})

export type V2CursorPagination = z.infer<typeof V2CursorPaginationSchema>
